import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES, PAGE} from '../../../_config/strings';
import {Usuario} from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import {Subject} from 'rxjs/Subject';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import { ChatService } from '../../../_services/chat.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-almacen-en-espera',
  templateUrl: './almacen-en-espera.component.html',
  styleUrls: ['./almacen-en-espera.component.scss']
})
export class AlmacenEnEsperaComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;

  // array´s
  arrayEspera = [];
  arrayMaterialAsignar = [];

  boolTrigger = true;

  numero = 0;

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
  }

  ngOnInit() {
    this.enEspera();
  }

  enEspera () {
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.espera,
      'GET',
      null
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 200 ) {
        for ( const materialEnEspera of response.Mensaje ) {
          this.arrayEspera.push({
            codigo: materialEnEspera.codigo,
            descripcion: materialEnEspera.descripcion,
            cantidad: materialEnEspera.cantidad,
            cantidadRestante: materialEnEspera.cantidad,
            fisico: 0,
            mantenimiento: 0,
            inservible: 0
          });
        }
        if (this.boolTrigger) {
          this.dtTrigger.next();
        }
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  calculoCantidades (espera) {
    // Prueba
    let sumaInputs = 0;
    const objeto = this.arrayEspera.find(e => e.codigo == espera.codigo);
    if (objeto) {
      sumaInputs = espera.fisico + espera.mantenimiento + espera.inservible;
      if ( sumaInputs <= objeto.cantidad ) {
        objeto.cantidadRestante = objeto.cantidad - sumaInputs;
      } else {
        swal('Se pasó', 'Vuelve a ingresar las cantidades', 'error');
      }
    }
  }

  enviarCantidades (espera) {
    this.arrayEspera = [];
    console.log( this.arrayEspera );
    const sumaInputs = espera.fisico + espera.mantenimiento + espera.inservible;
    if (sumaInputs > espera.cantidad) {
      espera.fisico = 0;
      espera.mantenimiento = 0;
      espera.inservible = 0;
      espera.cantidadRestante = espera.cantidad;
      swal('Error', 'Ingresa de nuevo las cantidades', 'error');
    } else {
      this.network.callSecureService(
        this.API.user.almacenes + '/' + this.API.user.espera + '/' + this.API.user.asignacion,
        'POST',
        espera
      ).subscribe((response: any) => {
        // console.log( response );
        if ( response.Estatus === 201 ) {
          Swal('Correcto', response.Mensaje , 'success');
          this.boolTrigger = false;
          this.enEspera();
        }
      }, err => {
        console.log(err);
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
      });
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/almacen-en-espera/almacen-en-espera.component.ts